module.exports = __webpack_public_path__ + "img/ibmp_nasal_passo_1.15905897.gif";